import axios from 'axios'

export default async function Author(callback) {

    const AuthKey = localStorage.getItem('key')

	if (AuthKey === '' || AuthKey === null || AuthKey === undefined) {

        callback(false)
        return
    
    } 

    headerInjection(AuthKey)


    await axios.get('/api/auth/validate')
    .then(res => {

        if (res.status === 200 && res.data.info === 'xsj3d03l2zai') {
            
            callback(true)

        } else {

            callback(false)

        }

    })
    .catch(err => { 
        
        callback(false)

    })

}


function headerInjection(key) {

    axios.interceptors.request.use( config => {

        config.headers.Authorization = key
        return config

    	}, (err) => { return Promise.reject(err) }
    
    )

} 



// WEBPACK FOOTER //
// ./src/controller/Author.js